import type { Lang } from './i18n';

// Official App Store / Google Play badge artwork (Apple Marketing Tools + Google Play badge
// generator), one file per locale in public/badges. Always shown at the same height, per the
// stores' badge guidelines.
export const appStoreBadge = (lang: Lang) => `/badges/app-store-${lang}.svg`;
export const googlePlayBadge = (lang: Lang) => `/badges/google-play-${lang}.png`;

/** Badge pair as an HTML string, for markdown-rendered blog content. */
export function storeBadgesHtml(lang: Lang, iosHref: string, androidHref: string, height = 48): string {
  const a = (href: string, src: string, alt: string) =>
    `<a href="${href}" target="_blank" rel="noopener noreferrer" class="store-badge badge-press inline-flex"><img src="${src}" alt="${alt}" style="height:${height}px;width:auto" loading="lazy" /></a>`;
  return (
    a(iosHref, appStoreBadge(lang), 'Download on the App Store') +
    a(androidHref, googlePlayBadge(lang), 'Get it on Google Play')
  );
}
